import { getDigitalRequestJsonUrlApi } from '../api/digital_request_api';
import { fetchJsonFromS3Url } from '../api/s3_file_api';

export async function getBeneficiaryFromRequest(id) {
  try {
    const { s3Key } = await getDigitalRequestJsonUrlApi(id);
    if (!s3Key) throw new Error('No form file found for this request');
    const beneficiareData = await fetchJsonFromS3Url(s3Key);
    
    return {
      id: beneficiareData.beneficiaryIdNumber,
      first_name: beneficiareData.beneficiaryFirstName,
      last_name: beneficiareData.beneficiaryLastName,
      city: beneficiareData.beneficiaryCity || '',
      address: beneficiareData.beneficiaryAddress || '',
      father_name: beneficiareData.beneficiaryFatherName || '',
      mother_name: beneficiareData.beneficiaryMotherName || '',
      phone: beneficiareData.beneficiaryPhone || '',
      email: beneficiareData.beneficiaryEmail || '',
      type_case: '',
      comments: beneficiareData.admin_comments || '',
      referring_teacher: (beneficiareData.caregiverContactName ? beneficiareData.caregiverContactName : (beneficiareData.firstName + ' ' + (beneficiareData.lastName || ''))) || '',
      teacher_phone: beneficiareData.caregiverContactPhone ? beneficiareData.caregiverContactPhone : (beneficiareData.phone || ''),
      supplier_name: beneficiareData.supplierName || '',
      join_date: new Date().toISOString().split('T')[0]
    };
  } catch (err) {
    console.error('Error in getBeneficiaryFromRequest:', err);
    throw err;
  }
}